'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { LocaleSwitcher } from '@/components/i18n/LocaleSwitcher';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { track } from '@/lib/analytics/ym';
import { SITE } from '@/lib/site-config';

const links = [
  { href: '/#cases', key: 'cases' },
  { href: '/#process', key: 'process' },
  { href: '/#faq', key: 'faq' },
] as const;

export function Navbar() {
  const t = useTranslations('Navbar');

  return (
    <header className="sticky top-0 z-40 border-b bg-background/80 backdrop-blur-md">
      <nav className="container mx-auto flex h-16 items-center justify-between px-4 md:h-18">
        <Link href="/" className="font-semibold tracking-tight">
          {SITE.brand}
        </Link>
        <ul className="hidden items-center gap-6 md:flex">
          {links.map((l) => (
            <li key={l.href}>
              <Link href={l.href} className="text-sm text-muted-foreground hover:text-foreground">
                {t(`links.${l.key}`)}
              </Link>
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-3">
          <LocaleSwitcher />
          <ThemeToggle />
          <Link
            href="/#lead"
            onClick={() => track.ctaClick('navbar')}
            className={cn(buttonVariants({ size: 'sm' }), 'hidden md:inline-flex rounded-full')}
          >
            {t('cta')}
          </Link>
        </div>
      </nav>
    </header>
  );
}
